<h1 mat-dialog-title>Zugänge an HIT melden</h1>
<div mat-dialog-content class="hit-melden-content">
    <div class="hit-melden-option">
        <mat-checkbox [disabled]="anzahl_pass_ohrmarke <= 0 || isLoading" [(ngModel)]="pass_und_ohrmarke"
            >Ohrmarke und Pass gescannt ({{ anzahl_pass_ohrmarke }}
            Stk.)
        </mat-checkbox>
    </div>

    <div class="hit-melden-option">
        <mat-checkbox [disabled]="anzahl_pass <= 0 || isLoading" [(ngModel)]="nur_pass_gescannt"
            >nur Pass gescannt ({{ anzahl_pass }} Stk.)
        </mat-checkbox>
    </div>

    <div class="hit-melden-option">
        <mat-checkbox [disabled]="anzahl_ohrmarke <= 0 || isLoading" [(ngModel)]="nur_ohrmarke_gescannt"
            >nur Ohrmarke gescannt ({{ anzahl_ohrmarke }} Stk.)
        </mat-checkbox>
    </div>

    <div class="hit-melden-option">
        <mat-checkbox [disabled]="anzahl_csv <= 0 || isLoading" [(ngModel)]="weder_pass_noch_ohrmarke"
            >nur CSV-Import ({{ anzahl_csv }} Stk.)
        </mat-checkbox>
    </div>

    <div *ngIf="nicht_meldbar" class="one-row hit-warning-row">
        <mat-icon color="warn">warning</mat-icon>
        <span>Tiere ohne Einstalldatum: {{ nicht_meldbar }}</span>
        <span class="spacer"></span>
        <button mat-stroked-button color="warn" (click)="tiereOhneEinstalldatumAnzeigen()">anzeigen</button>
        <span class="spacer"></span>
    </div>
</div>
<div mat-dialog-actions class="hit-melden-actions">
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-flat-button color="accent" [disabled]="isLoading || submitLocked || !canSubmitMelden" (click)="save()">
        Tier(e) melden
    </button>
</div>
